/**
 * The administrator's line above the object screen and «Налаштування»:
 * whose object it is (name, phone, email) and that changes go to the
 * object's journal. Nothing for a client.
 */
import { useAdminSites } from '../hooks/use-admin-sites.js';
import { useProfile } from '../hooks/use-profile.js';
import { useLocale } from '../i18n/locale-context.js';

export function AdminBanner({ siteId }: { siteId: string }) {
  const { t, tf } = useLocale();
  const { data: profile } = useProfile();
  const isAdmin = profile?.role === 'operator';
  const sites = useAdminSites(isAdmin);
  if (!isAdmin) return null;
  const client = sites.data?.find((s) => s.site_id === siteId)?.client;
  const who = client ? [client.name, client.phone, client.email].filter(Boolean).join(', ') : '…';
  return (
    <div className="note">
      <b>{t('admin.banner.role')}</b> · {tf('admin.banner.client', { client: who })} ·{' '}
      {t('admin.banner.journal')}
    </div>
  );
}
